import { render, staticRenderFns } from "./buy_succeed.vue?vue&type=template&id=9561c40a&scoped=true"
import script from "./buy_succeed.vue?vue&type=script&lang=js"
export * from "./buy_succeed.vue?vue&type=script&lang=js"
import style0 from "./buy_succeed.vue?vue&type=style&index=0&id=9561c40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9561c40a",
  null
  
)

export default component.exports